import React from "react";
import Menu from "../Menu/Menu";
import "./Header.css";

const Header = ({
  selectedType,
  fromDate,
  toDate,
  keyword,
  isMenuOpen,
  onTypeChange,
  onFromDateChange,
  onToDateChange,
  onKeywordChange,
  onToggleMenu,
  onClearFilters,
}) => (
  <div className="header-wrapper">
    
    <header>
      <img
        src={`${process.env.PUBLIC_URL || ""}/billbuddyai.png`}
        alt="Bill Buddy AI"
      />
    </header>
    
    <p className="catchphrase">
      Simplifying policy and laws — one bill at a time.
    </p>

    <Menu
      selectedType={selectedType}
      fromDate={fromDate}
      toDate={toDate}
      keyword={keyword}
      isMenuOpen={isMenuOpen}
      onTypeChange={onTypeChange}
      onFromDateChange={onFromDateChange}
      onToDateChange={onToDateChange}
      onKeywordChange={onKeywordChange}
      onToggleMenu={onToggleMenu}
      onClearFilters={onClearFilters}
    />
  </div>
);

export default Header;
